/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, Injectable, signal } from '@angular/core';
import { MOBILE_DEVICE_CHECK_LIST_REGEX } from '@shared/const';
import { DeviceTypeEnum } from '@shared/enums/device-type.enum';
import { DeviceType } from '@shared/types';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectionService {
  private isMobile = signal(this.checkIfMobile());

  // Expose as computed signal for reactive updates
  public readonly isMobileDevice = computed(() => this.isMobile());

  constructor() {
    // Update on window resize
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.isMobile.set(this.checkIfMobile());
      });
    }
  }

  private checkIfMobile(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;

    // Additional check for touch-enabled devices with small screens
    const isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return (
      MOBILE_DEVICE_CHECK_LIST_REGEX.test(userAgent.toLowerCase()) ||
      (isTouchDevice && isSmallScreen)
    );
  }

  getDeviceType(): DeviceType {
    if (typeof navigator === 'undefined') return DeviceTypeEnum.DESKTOP;

    const userAgent = navigator.userAgent.toLowerCase();

    if (/ipad|android(?!.*mobile)|tablet/i.test(userAgent)) {
      return DeviceTypeEnum.TABLET;
    }

    if (
      /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      )
    ) {
      return DeviceTypeEnum.MOBILE;
    }

    return DeviceTypeEnum.DESKTOP;
  }
}
